
    var css = require("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[3]!./Loader.scss");
    var content = typeof css === 'string' ? [[module.id, css, '']] : css;

    var changeListeners = [];
    var api = {
      content: function() {
        return {
          id: String(module.id),
          css: String(css),
          media: content[0][2]
        };
      },
    };
    
    // Hot Module Replacement
    if (module.hot && typeof window !== 'undefined' && window.document) {
      api.addChangeListener = function(listener) {
        if (typeof listener === 'function' && changeListeners.indexOf(listener) < 0) {
          changeListeners.push(listener);
          return function() {
            var index = changeListeners.indexOf(listener);
            if (index >= 0) {
              changeListeners.splice(index, 1);
            }
          }
        }
      },
      module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[3]!./Loader.scss", function() {
        css = require("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[3]!./Loader.scss");
        content = typeof css === 'string' ? [[module.id, css, '']] : css;
        changeListeners.forEach(function(listener) {
          listener(api.content());
        });
      });
    }
    
    // Module exports
    module.exports = content.locals || {};
    module.exports._api = api;
    